/**
 * Marca formularios con cambios para Safe Update Guard.
 * @module hooks/useSafeUpdateFormGuard
 */

import { useEffect } from 'react';
import { setFormDirty } from '../utils/criticalOperationGuard';

/**
 * @param {string} scope — identificador del formulario (producto, compra, usuario, …)
 * @param {boolean} isDirty — true si hay cambios sin guardar
 */
export function useSafeUpdateFormGuard(scope, isDirty) {
  useEffect(() => {
    setFormDirty(scope, Boolean(isDirty));
    return () => setFormDirty(scope, false);
  }, [scope, isDirty]);
}

/**
 * @param {boolean} active — true mientras hay operación en curso (caja, pago, carrito)
 * @param {(active: boolean) => void} setter — setCajaOperacionEnCurso, setDesktopPosCartActive, etc.
 */
export function useSafeUpdateOperationGuard(active, setter) {
  useEffect(() => {
    setter(Boolean(active));
    return () => setter(false);
  }, [active, setter]);
}
